import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';


@Component({
  selector: 'app-gdpr',
  templateUrl: './gdpr.component.html',
  styleUrls: ['./gdpr.component.scss']
})
export class GdprComponent implements OnInit {
  safeURL; //youTube Video URL //

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Gather information about CViewSurvey application GDPR (General Data Protection Regulation) by reaching out to this page. Contact our team for any queries regarding our survey app.' },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'Survey App, Survey App for Android, survey application' }
    ]);

    this.setTitle('GDPR | Best Survey App for Android and IOS | CViewSurvey');
    // End SEO Meta Description


    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/EsPq62yE3AE');
    // End You Tube Video Description

  }

  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description


  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();
  }

}
